const progressUrl = "https://cityprogress.sbmurban.org";
const baseUrl = "https://dev.sbmurban.org";
const uploadImage = "http://165.22.216.228:8083/";

export const environment = {
  version: "0.0.0",
  production: false,
  baseUrl: baseUrl,
  config: {
    feedbackUrl: baseUrl + "/api/v1/feedback/",
    apiUrl: baseUrl + "/api/v1/",
    iecUrl: baseUrl + "/api/v1/iec/",
    iecUrlSwach: baseUrl + "/api/v1/safaimitra/",
    vendorSso: baseUrl + "/api/v1/sso_vendor/",
    classification: baseUrl + "/api/v1/classification/",
    pts: baseUrl + "/api/v1/proposal/",
    analysis: baseUrl + "/api/v1/analysis/",
    odfUrl: baseUrl + "/api/v1/odf/",
    odfFaUrl: baseUrl + "/api/v1/odffieldassessment/",
    odfAppUrl: baseUrl + "/api/v1/",
    gfcUrl: baseUrl + "/api/v1/gfc/",
    gfcAppUrl: baseUrl + "/api/v1/gfcapp/",
    mediaUrl: baseUrl + "/api/v1/media/",
    fileGeneration: baseUrl + "/api/v1/file/",
    compostUrl: baseUrl + "/api/v1/compost/",
    systemSettings: baseUrl + "/api/v1/system/",
    city: baseUrl + "/api/v1/cityprofile/",
    cityStaticUrl: uploadImage,
    cityProgress: baseUrl + "/api/v1/cityprofile/",
    monthlyProgress: baseUrl + "/api/v1/progress/",
    stateProgress: progressUrl + "/api/stateprogress/",
    gtlUrl: baseUrl + "/api/v1/gtl/",
    gtlStaticUrl: baseUrl + "/gtl/static/image/",
    loginUrl: baseUrl + "/api/v1/sso/",
    vendorUrl: baseUrl + "/api/v1/vendor/",
    vendorStaticUrl: baseUrl + "/",
    staticUrl: baseUrl + "/static/uploads/",
    staticUrlForImage: baseUrl + "/api/v1/cityprofile/",
    certificateUrl: baseUrl + "/api/v1/certificate/",
    eventsUrl: "https://swachhmanchapi.sbmurban.org/",
    grievanceUrl: baseUrl + "/",
    baseUrl,
    ptsServiceUrl: "https://pts.sbmurban.org/pts/",
    proposalSer: "https://f8746cc6-08bf-4fb7-9508-1de575ad6cdd.mock.pstmn.io/",
    safaiMitra: baseUrl + "/api/v1/safaimitra/",
    reports: baseUrl + "/api/v1/dashboards_reports/",
    actionPlan: baseUrl + "/api/v1/action/action/",
    ssApi: baseUrl + "/api/v1/" + "ssulb/ss/api",
    ssMissionApi: baseUrl + "/api/v1/" + "ssmission1/ss/api",
    ssLogin: baseUrl + "/login",
    ranking_api_url: baseUrl + "/api/v1/" + "ssulbranking/ss/api",
    ranking_api_secured_url:
    baseUrl + "/api/v1/" + "ssulbranking/ss/secured/api",
    factsheet_api: baseUrl + "/api/v1/" + "dashboard/report-dashboard/",
    dbt_media_api: baseUrl + "/api/v1/" + "dbt/dbt-service/upload",
    dbt_url: baseUrl + "/api/v1/" + "dbt/dbt-service/",
    pms: baseUrl + "/api/v1/pms/",
    prayasData: baseUrl + "/api/v1/" + "analysis/",

  },
};
